import React from 'react';
import DrawerButton from '../Button/DrawerButton';
import SleekPanel from 'images/best-electric-vehicles/solarpanel.png';
import Image from 'next/legacy/image';
import { H4 } from '../Element/Heading';

interface PanelCardProps {
  panel365: string;
  panel400: string;
  panel440: string;
}

const PanelCard: React.FC<PanelCardProps> = ({
  panel365,
  panel400,
  panel440,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="flex flex-col justify-center items-center">
        <div className="bg-slate-200 rounded-md flex items-center flex-col w-auto py-4">
          <H4 className="text-primary-500 font-medium w-full text-center">
            365W
          </H4>
          <div className="w-1/3 md:w-full">
            <Image src={SleekPanel} alt="Solar panel" />
          </div>
          <p className="text-primary-500 text-3xl font-medium bg-gray-300 p-1 w-full text-center">
            {panel365} Panels
          </p>
          <div className="py-2 m-2">
            <DrawerButton />
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center">
        <div className="bg-slate-200 rounded-md flex items-center flex-col w-auto py-4">
          <H4 className="text-primary-500 font-medium w-full text-center">
            400W
          </H4>
          <div className="w-1/3 md:w-full">
            <Image src={SleekPanel} alt="Solar panel" />
          </div>
          <p className="text-primary-500 text-3xl font-medium bg-gray-300 p-1 w-full text-center">
            {panel400} Panels
          </p>
          <div className="py-2 m-2">
            <DrawerButton />
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center">
        <div className="bg-slate-200 rounded-md flex items-center flex-col w-auto py-4">
          <H4 className="text-primary-500 font-medium w-full text-center">
            440W
          </H4>
          <div className="w-1/3 md:w-full">
            <Image src={SleekPanel} alt="Solar panel" />
          </div>
          <p className="text-primary-500 text-3xl font-medium bg-gray-300 p-1 w-full text-center">
            {panel440} Panels
          </p>
          <div className="py-2 m-2">
            <DrawerButton />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PanelCard;
